module.exports = __webpack_public_path__ + "img/tarjeta_servicios_carglass.23d27399.jpg";